// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"cdccf2b4","726":"2a5bcb98"}[chunkId] + ".chunk.js";
};